package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
actual data class Post(
    @SerialName("_id")
    actual var id:String? = null,
    actual var userId:String? = null,
    actual var date:Long? = null,
    actual var title:String? = null,
    actual var subtitle:String? = null,
    actual var content:String ? = null,
    actual var image:String? = null,
    actual var category:Category? = Category.NoCategory,
    actual var popular:Boolean? = null,
    actual var favorite:Boolean? = null,
    actual var visible:Boolean? = null,
)



